export const CONCERTS_SLUGS = [
  'rock-pop',
  'alternative-rock',
  'dance-electronic',
  'country-folk',
  'rap-hip-hop',
  'hard-rock-metal',
];
